import { get as getCookie } from './services/cookie-storage-service';
import config from './config';

let preventLoad = false;

if (window?.location?.pathname === '/token') {
    preventLoad = true;
    const { masterToken, teamUrl } = (getCookie('auth') || {});

    window.parent.postMessage({ masterToken, teamUrl }, `https://${config.LANDING_DOMAIN}`);
}

export const preventAppLoad = preventLoad;
